import React from 'react';
import { ExternalLink } from 'lucide-react';
import LegalLayout from './LegalLayout';

const COMPANY_ADDRESS = '서울특별시 강남구 테헤란로 123 (역삼동)';

// 시맨틱 정의 목록 렌더링 헬퍼
const InfoRow = ({ label, children }) => (
  <div className="flex flex-col gap-0.5 sm:flex-row sm:gap-3">
    <dt className="w-44 shrink-0 font-medium text-primary">{label}</dt>
    <dd className="text-accent-700">{children}</dd>
  </div>
);

const CompanyInfoPage = () => {
  const sections = [
    { id: 'company', label: '회사 정보' },
    { id: 'contact', label: '연락처 정보' },
    { id: 'cs', label: '고객센터' },
    { id: 'etc', label: '기타 정보' },
  ];

  return (
    <LegalLayout title="사업자 정보" sections={sections}>
      <section id="company">
        <h2 className="text-xl font-semibold text-primary mb-4">회사 정보</h2>
        <dl className="space-y-2">
          <InfoRow label="상호명">(주)모바일장례서비스</InfoRow>
          <InfoRow label="대표자">홍길동</InfoRow>
          <InfoRow label="사업자등록번호">123-45-67890</InfoRow>
          <InfoRow label="통신판매업신고번호">
            제2024-서울강남-12345호{' '}
            <a
              href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1234567890"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-sm text-primary-700 hover:underline"
            >
              사업자정보 확인
              <ExternalLink size={14} aria-hidden="true" />
            </a>
          </InfoRow>
        </dl>
      </section>

      <section id="contact">
        <h2 className="text-xl font-semibold text-primary mb-4">연락처 정보</h2>
        <dl className="space-y-2">
          <InfoRow label="주소">{COMPANY_ADDRESS}</InfoRow>
          <InfoRow label="대표전화">
            <a href="tel:0212345678" className="text-primary-700 hover:underline">
              02-1234-5678
            </a>
          </InfoRow>
          <InfoRow label="팩스">02-1234-5679</InfoRow>
          <InfoRow label="이메일">
            <a
              href="mailto:support@mobilefuneral.co.kr"
              className="text-primary-700 hover:underline"
            >
              support@mobilefuneral.co.kr
            </a>
          </InfoRow>
        </dl>

        {/* 약도(지도 임베드) */}
        <div className="mt-4 overflow-hidden rounded-lg border border-accent-200">
          <iframe
            title="회사 위치 지도"
            src={`https://maps.google.com/maps?q=${encodeURIComponent(
              COMPANY_ADDRESS
            )}&output=embed`}
            className="h-64 w-full"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>

      <section id="cs">
        <h2 className="text-xl font-semibold text-primary mb-4">고객센터</h2>
        <dl className="space-y-2">
          <InfoRow label="운영시간">
            평일 09:00 ~ 18:00 (주말 및 공휴일 휴무)
          </InfoRow>
          <InfoRow label="상담전화">
            <a href="tel:15881234" className="text-primary-700 hover:underline">
              1588-1234
            </a>
          </InfoRow>
          <InfoRow label="상담 이메일">
            <a
              href="mailto:cs@mobilefuneral.co.kr"
              className="text-primary-700 hover:underline"
            >
              cs@mobilefuneral.co.kr
            </a>
          </InfoRow>
        </dl>
      </section>

      <section id="etc">
        <h2 className="text-xl font-semibold text-primary mb-4">기타 정보</h2>
        <dl className="space-y-2">
          <InfoRow label="호스팅 서비스 제공자">AWS</InfoRow>
          <InfoRow label="개인정보관리책임자">
            김철수 (
            <a
              href="mailto:privacy@mobilefuneral.co.kr"
              className="text-primary-700 hover:underline"
            >
              privacy@mobilefuneral.co.kr
            </a>
            )
          </InfoRow>
        </dl>
      </section>

      <div className="mt-8 p-4 bg-accent-50 rounded-lg border border-accent-200">
        <p className="text-sm text-accent-700">
          본 사이트는 프론트엔드 목업 프로젝트로, 실제 운영되는 서비스가 아닙니다.
          모든 정보는 예시를 위한 것이며, 실제 사업자 정보와 무관합니다.
        </p>
      </div>
    </LegalLayout>
  );
};

export default CompanyInfoPage;
